import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BroadcastService } from '@core/services';

import { AuthService } from '@auth/services';

@Component({
  selector: 'z-broadcast-debug',
  styleUrls: ['./broadcast-debug.component.scss'],
  templateUrl: './broadcast-debug.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BroadcastDebugComponent {
  constructor(public broadcastService: BroadcastService, public authService: AuthService) {}
}
